<!-- メニュー -->
<app-menu></app-menu>

<!-- メイン -->
<div class="main">
  <!-- メインコンテンツ -->
  <div class="main-content" [class.platform-large-text]="getTextSize()">
    <!-- タイトル -->
    <div class="page-title">
      <i class="pi pi-link"> </i>
      <label class="name">自治体の声</label>
    </div>

    <!-- ガード文言 -->
    <p>
      ※各会員の連携事例等について、当プラットフォーム及び運営事務局(内閣府)が管理・保証するものではありません。
    </p>

    <div class="search-flex">
      <!-- 検索条件入力 -->
      <div class="search-form-area">
        <form
          [formGroup]="j101SearchForm"
          (ngSubmit)="getResultArticleDataList(true,true)"
        >
          条件を指定して「<i class="pi pi-search"></i>」をクリック
          <div class="p-d-flex p-jc-between">
            <!-- 検索テキスト -->
            <div class="search-text">
              <input
                type="text"
                pInputText
                placeholder="フリーワード検索"
                (focus)="text_focus.toggle($event)"
                (blur)="text_focus.toggle($event)"
                formControlName="freeword"
              />
              <p-overlayPanel #text_focus>
                <ng-template pTemplate>
                  <div class="overlay-search-text">さらに絞り込む</div>
                </ng-template>
              </p-overlayPanel>
            </div>
            <!-- 検索ボタン -->
            <button
              pButton
              type="submit"
              icon="pi pi-search"
              class="button1 search-button"
              (click)="getResultArticleDataList(true,true)"
            ></button>
          </div>

        </form>
      </div>
      <!-- 結果表示 -->
      <div class="result-area">
        <!-- ページアンカー -->
        <a id="jump-top"></a>

        <p-dataView
          #table
          [value]="resultArticleDataList"
          [paginator]="true"
          [rows]="15"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="{first}~{last}件表示({totalRecords}件中)"
          [rowsPerPageOptions]="[15, 75, 150]"
          emptyMessage="データが存在しません"
          layout="grid"
          (onPage)="jumpTop()"
          [sortField]="sortField"
          [sortOrder]="sortOrder"
        >
          <!-- ヘッダー -->
          <ng-template pTemplate="header">
            <!-- 検索結果数 -->
            <div class="p-d-flex p-jc-between result-count-area">
              <div>
                <label class="count">
                  {{ resultArticleDataList.length }}
                </label>
                件（総件数：{{ countArticleData }}件）
              </div>
              <div class="p-as-center p-d-flex">
                <!-- ソート順の項目をここに記載する -->
                <div class="p-as-center">表示切替：</div>
                <p-dropdown
                  [options]="sortOptions"
                  [(ngModel)]="sortKey"
                  placeholder="選択してください"
                  (onChange)="onSortChange($event)"
                  styleClass="mb-2 md:mb-0"
                ></p-dropdown>
              </div>
            </div>
          </ng-template>
          <!-- グリッドアイテム -->
          <ng-template let-resultArticleData pTemplate="gridItem">
            <div class="p-col-12 p-md-4">
              <a
                class="item-area item"
                [attr.href]="resultArticleData?.article_url"
                style="text-decoration:none; color: inherit;"
                target="_blank" >
                <div class="article-new-tag-container" *ngIf="isWithinLastMonth(resultArticleData?.create_datetime)">
                  <p-tag value="NEW" styleClass="article-new-tag"  *ngIf="isWithinLastMonth(resultArticleData?.create_datetime)"></p-tag>
                </div>
                <!-- 事例イメージ -->
                <div class="image">
                  <img
                    [src]="resultArticleData?.article_image.file_path"
                    alt="image"
                  />
                </div>
                <!-- 事例タグ -->
                <div class="title">{{ resultArticleData.title }}</div>
                <div class="description">{{ resultArticleData.description }}</div>
              </a>
            </div>
          </ng-template>
        </p-dataView>
      </div>
    </div>
  </div>
</div>

<!-- フッダー -->
<footer>
  <app-footer></app-footer>
</footer>
